import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-pycnometer-vertical',
  standalone: false,
  templateUrl: './pycnometer-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class PycnometerVerticalComponent {
@Input() pycnometerTest:any
ngOnInit() {
}
}
